import { useEffect, useState } from 'react';
import { useInView, IntersectionOptions } from 'react-intersection-observer';

const useInfiniteScroll = (callback: () => Promise<void> | void, options: IntersectionOptions = {}) => {
  const [isFetching, setIsFetching] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0,
    ...options,
  });

  useEffect(() => {
    if (inView && !isFetching) {
      setIsFetching(true);
      const result = callback();
      if (result && typeof result.then === 'function') {
        result.finally(() => {
          setIsFetching(false);
        });
      } else {
        setIsFetching(false);
      }
    }
  }, [inView, callback, isFetching]);

  return { ref, isFetching };
};

export default useInfiniteScroll; 